import React from 'react'
import { useNavigate } from 'react-router-dom'
import './thanks.css'

const Thanks = () => {
    const navigate = useNavigate();
    return (
        <div className='ThankYou-Main'>
            <div className='ThankYou-Detail'>
                <h1 className="thank-you-heading">Thank You!</h1>
                <p className="thank-you-message">
                    You’ve been logged out successfully.<br />
                    We truly appreciate your time with us.
                </p>
                <p className="thank-you-subtext">
                    Want to come back? Just log in again below.
                </p>
                <button className="login-again-btn" onClick={() => navigate("/login")}>Login</button>
            </div>
        </div>
    )
}

export default Thanks